<template>
  <div class="detail-container">
    <detail :data='detailData'></detail>
  </div>
</template>

<script>
import detail from "@/views/FundManagement/components/detail";
import { getDetailMgr } from "common/js/api";

export default {
  components: {
    detail
  },

  data() {
    return {
      institutionCode:this.$route.query.institutionCode,
      detailData:{}
    }
  },

  mounted() {
    this.getDetail();
  },

  methods:{
    async getDetail() {
      const res = await getDetailMgr(this.institutionCode);
      this.detailData = res.result;
    }
  }
};
</script>

<style>
</style>

